module.exports = __webpack_public_path__ + "static/media/logo_stuttgart_black.b226db46.svg";